export const REMOVE_IMPORTED_FILE = "REMOVE_IMPORTED_FILE";
export const SELECTED_CONTACTS_UPDATE = "SELECTED_CONTACTS_UPDATE";

//
//  ******* Import Excel file Related *******
//

export const IMPORT_EXCEL_FILES_BEGIN = "IMPORT_EXCEL_FILES_BEGIN";
export const IMPORT_EXCEL_FILES_SUCCESS = "IMPORT_EXCEL_FILES_SUCCESS";
export const IMPORT_EXCEL_FILES_FAIL = "IMPORT_EXCEL_FILES_FAIL";

//
//  ******* Send Email Invitation Related *******
//

export const SUPPLIER_IMPORT_INVITE_BEGIN = "SUPPLIER_IMPORT_INVITE_BEGIN";
export const SUPPLIER_IMPORT_INVITE_SUCCESS = "SUPPLIER_IMPORT_INVITE_SUCCESS";
export const SUPPLIER_IMPORT_INVITE_FAIL = "SUPPLIER_IMPORT_INVITE_FAIL";

//
//  ******* Supplier Flow Related *******
//

export const SUPPLIER_INVITATION_INIT = "SUPPLIER_INVITATION_INIT";
export const SUPPLIER_INVITATION_RESET = "SUPPLIER_INVITATION_RESET";
